import { render } from "./ModernHeader.vue?vue&type=template&id=fe30ae74&scoped=true"
import script from "./ModernHeader.vue?vue&type=script&lang=js"
export * from "./ModernHeader.vue?vue&type=script&lang=js"

import "./ModernHeader.vue?vue&type=style&index=0&id=fe30ae74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe30ae74"]])

export default __exports__